import moment from "moment-timezone";

export const humanizeTimestamp = (
  timestamp,
  format = "MMMM DD, YYYY [·] hh:mm a z",
  timezone = moment.tz.guess()
) => {
  return moment.unix(timestamp).tz(timezone).format(format);
};

// For calendar-date concepts that are stored in datetime columns (e.g. headcount
// opportunity start/end dates). Render in the app's business timezone (Eastern)
// so the date matches what admins enter and what the rest of the app displays,
// instead of shifting based on the viewer's local timezone.
const APP_TIME_ZONE = "America/New_York";

export const humanizeDate = (isoTimestamp, format = "MMM DD, YYYY") => {
  return moment.tz(isoTimestamp, APP_TIME_ZONE).format(format);
};

export const humanizeTimestampWithSmartTimezone = (
  timestamp,
  format = "MMMM DD, YYYY [·] hh:mm a z",
  timezone = moment.tz.guess()
) => {
  const momentObj = moment.unix(timestamp).tz(timezone);
  const formattedWithTimezone = momentObj.format(format);

  // Extract the timezone part from the formatted string
  const timezonePart = momentObj.format("z");

  // Check if it's a numeric offset (like "-03", "+05", "-0530")
  const numericOffsetRegex = /^[+-]\d{2}(\d{2})?$/;

  let result = formattedWithTimezone;

  if (numericOffsetRegex.test(timezonePart)) {
    // It's a numeric offset, convert to GMT format
    const offset = momentObj.utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    const gmtOffset =
      minutes === 0
        ? `GMT${sign}${hours}`
        : `GMT${sign}${hours}:${minutes.toString().padStart(2, "0")}`;

    // Replace the numeric offset with GMT format
    result = formattedWithTimezone.replace(timezonePart, gmtOffset);
  }

  return result;
};

export const getTimeElapsed = (timestamp) => {
  const now = moment();
  const past = moment.unix(timestamp);
  const duration = moment.duration(now.diff(past));

  if (duration.asSeconds() < 60) {
    return `${Math.floor(duration.asSeconds())} sec`;
  }

  if (duration.asMinutes() < 60) {
    return `${Math.floor(duration.asMinutes())} min`;
  }

  return `${Math.floor(duration.asHours())} hr`;
};
